import { Component } from '@angular/core';
import { ChallengesSubChallengesComponent } from './challenges-sub-challenges/challenges-sub-challenges.component';
import { SelectedPairChallengesComponent } from './selected-pair-challenges/selected-pair-challenges.component';

@Component({
  selector: 'app-select-challenges-container',
  imports: [ChallengesSubChallengesComponent, SelectedPairChallengesComponent],
  templateUrl: './select-challenges-container.component.html',
  styleUrl: './select-challenges-container.component.scss',
})
export class SelectChallengesContainerComponent {}
